import {
    ACTION_UPLOAD_TMP,
    ACTION_UPLOAD_LOCK,
    ACTION_UPLOAD_TMP_DELETE,
    ACTION_UPLOAD_LOCK_DELETE,
    ACTION_UPLOAD_TMP_PROCESS,
    ACTION_UPLOAD_TMP_DONE,
    ACTION_UPLOAD_LOCK_PROCESS,
    ACTION_UPLOAD_LOCK_DONE,
    ACTION_UPLOAD_COVER,
    ACTION_UPLOAD_COVER_DELETE,
    ACTION_UPLOAD_COVER_PROCESS,
    ACTION_UPLOAD_COVER_DONE,
} from "../actions/tmpUpload";

const initialState = {
    image: {},
    tempIsUploading: false,
    lockable: {},
    lockableIsUploading: false,
    cover: {},
    coverIsUploading: false,
};

export default function tmpUpload(state = initialState, { type, payload }) {
    switch (type) {
        case ACTION_UPLOAD_TMP:
            return { ...state, image: payload };
        case ACTION_UPLOAD_COVER:
            return { ...state, cover: payload };
        case ACTION_UPLOAD_LOCK:
            return { ...state, lockable: payload };
        case ACTION_UPLOAD_TMP_DELETE:
            return { ...state, image: {} };
        case ACTION_UPLOAD_COVER_DELETE:
            return { ...state, cover: {} };
        case ACTION_UPLOAD_LOCK_DELETE:
            return { ...state, lockable: {} };
        case ACTION_UPLOAD_TMP_PROCESS:
            return { ...state, tempIsUploading: true };
        case ACTION_UPLOAD_TMP_DONE:
            return { ...state, tempIsUploading: false };
        case ACTION_UPLOAD_COVER_PROCESS:
            return { ...state, coverIsUploading: true };
        case ACTION_UPLOAD_COVER_DONE:
            return { ...state, coverIsUploading: false };
        case ACTION_UPLOAD_LOCK_PROCESS:
            return { ...state, lockableIsUploading: true };
        case ACTION_UPLOAD_LOCK_DONE:
            return { ...state, lockableIsUploading: false };
        default:
            return state;
    }
}
